<template>
  <section class="trust">

    <div class="section-header">
      <h2 class="section-title">
        Ils nous font confiance
        <span class="section-title__underline" aria-hidden="true"></span>
      </h2>
    </div>

    <div class="trust__logos">
      <div
        v-for="logo in logos"
        :key="logo.alt"
        class="trust__logo-card"
      >
        <img :src="logo.img" :alt="logo.alt" class="trust__logo-img" />
      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'TrustSection',

  data() {
    return {
      logos: [
        { alt: 'Like.Dress',    img: require('@/assets/img/lik.png') },
        { alt: 'VGS Store',     img: require('@/assets/img/vgs.png') },
        { alt: 'MammaChia',     img: require('@/assets/img/ma.png') },
        { alt: 'Global Export', img: require('@/assets/img/ge.png') },
        { alt: 'WS',            img: require('@/assets/img/ws.png') },
        { alt: 'Noor',          img: require('@/assets/img/noor.png') },
      ],
    }
  },
}
</script>

<style scoped>
/* ════════════════════════════════════════════════
   TOKENS
════════════════════════════════════════════════ */
.trust {
  --font:          'Sora', 'DM Sans', system-ui, sans-serif;
  --color-text:    #1a1a1a;
  --color-border:  #e4e0d8;
  --color-accent:  #c8952b;
  --color-bg-card: #ffffff;
}

/* ════════════════════════════════════════════════
   SECTION
════════════════════════════════════════════════ */
.trust {
  padding: 0 50px 80px;
}

/* ════════════════════════════════════════════════
   TITRE
════════════════════════════════════════════════ */
.section-header {
  text-align: center;
  margin-bottom: 48px;
}

.section-title {
  position: relative;
  display: inline-block;
  margin: 0;
  font-family: var(--font);
  font-size: clamp(1.8rem, 3.5vw, 2.4rem);
  font-weight: 800;
  color: var(--color-text);
  letter-spacing: -0.02em;
  padding-bottom: 10px;
}

.section-title__underline {
  display: block;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 55%;
  height: 3.5px;
  background: var(--color-accent);
  border-radius: 2px;
}

/* ════════════════════════════════════════════════
   LOGOS GRILLE
════════════════════════════════════════════════ */
.trust__logos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  max-width: 760px;
  margin: 0 auto;
}

.trust__logo-card {
  width: 120px;
  height: 72px;
  background: var(--color-bg-card);
  border: 1.5px solid var(--color-border);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 14px;
  box-sizing: border-box;
  transition: box-shadow 0.2s ease;
}

.trust__logo-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.trust__logo-img {
  max-width: 130%;
  max-height: 130%;
  object-fit: contain;
  display: block;
  filter: grayscale(0.15);
}

/* ════════════════════════════════════════════════
   RESPONSIVE — Tablet (≤ 900px)
════════════════════════════════════════════════ */
@media (max-width: 900px) {
  .trust {
    padding-left: 24px;
    padding-right: 24px;
  }
}

/* ════════════════════════════════════════════════
   RESPONSIVE — Mobile (≤ 600px)
════════════════════════════════════════════════ */
@media (max-width: 600px) {
  .trust {
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 56px;
  }

  .trust__logo-card {
    width: 100px;
    height: 60px;
  }
}
</style>
